<script>
    import { warehouseMethods, inventoryMethods } from '@state/helpers'
    import BaseDatatable from '@components/base-datatable'
    import { mapGetters } from 'vuex'
    
    export default {
      name: 'InventoryTable',
      components: { BaseDatatable },
      data() {
        return {
          products: [],
          total_products: 0,
          /* ------------- table product props ------------------- */
          tableheadersproducts: [
            { key: 'name', label: 'Nombre:', class: 'mw-100' },
            { key: 'id_ext1', label: 'Extensión:', class: 'mw-100' },
            { key: 'existence', label: 'Existencia:', class: 'mw-100' },
            { key: 'batchs', label: 'Lotes:', class: 'ws-100' },
          ],
          /* ------------- table inventory props ------------------- */
          tableHeaders: [
            { key: 'name', label: 'Nombre'},
            { key: 'reference', label: 'Referencia'},
            { key: 'id_ext1', label: 'Extensión'},
            { key: 'existence', label: 'Existencia', sortByFormatted: true, filterByFormatted: true, 
                formatter: (value, key, item) => {
                  return this.quantity(item.batchs)
                }},
            { key: 'actions', label: 'Acciones' },
          ],
          infoModal: {
            id: 'info-modal',
            title: '',
            content: '',
          },
          totalRows: 100,
          currentPage: 1,
          perpage: 5,
          pageOptions: [5, 15, 50, 100, 1000],
          sortBy: '',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          filterOn: 'name',
          options: [
            { text: 'Nombre', value: 'name' },
            { text: 'Referencia', value: 'reference' },
            { text: 'Serial/Lote', value: 'batchs' },
          ],
        }
      },
      mounted() {
        this.myProvider()
      },
      computed: {
        ...mapGetters({
            own_warehouse_selected: 'retina/warehouse/own_warehouse_selected',
        }),
        sortOptions() {
          // Create an options list from our tableheaders
          return this.tableHeaders
            .filter((f) => f.sortable)
            .map((f) => {
              return { text: f.label, value: f.key }
            })
        },
      },
      methods: {
        ...inventoryMethods,
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
        myProvider(ctx) {
          let context = this
          let query_format = '?warehouse=' + this.own_warehouse_selected.id + '&ubication='
          //TODO: add here sort params
    
          const promise = this.fetchInventoryList(query_format)
          return promise
            .then((data) => {
              if (data && data.results){
                context.products = data.results
                context.totalRows = context.products.length
                context.sumQuantityItems()
              }
              return data
            })
            .catch((error) => {
              this.$axios_error_noty(error, this)
              // console.log(error)
              return []
            })
        },
        sumQuantityItems(){
          if (this.products.length === 0) return;
          let quantity = 0
          let items = this.products
          for (let i = 0; i < (items && items.length || 0); i++) {
            const item = items[i];
            if ('batchs' in item){
              for (let b = 0; b < item.batchs.length; b++) {
                quantity += item.batchs[b].quantity;
              }
            }
          }
          this.total_products = quantity
        },
        has_serial(batchs) {
          if (batchs.serials.length > 0) return true
          return false
        },
        quantity(list) {
          // let i = 0
          // list.forEach((dict) => (i += dict.quantity))
          // return i
          return list.map(x => x.serials.length > 0 ? x.serials.length : x.quantity).reduce((total, cant) => total + cant, 0)
        },
        verify_quantity(batchs, index) {
          if (this.items_by_batch[index] == 0) return null
          if (
            batchs.quantity >= this.items_by_batch[index] &&
            this.items_by_batch[index] > 0
          )
            return true
          return false
        },
        info(item, index, button) {
          this.infoModal.title = item.reference
          this.infoModal.content = item
          this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
          this.infoModal.title = ''
          this.infoModal.content = ''
        },
      },
    }
    </script>
    
    <template>
      <b-card>
        <!-- <b-card-title>
          Realizar pedido con:
        </b-card-title> -->
        <span class="text-primary">Total unidades: <b>{{ total_products }}</b></span>
        <div class="row mb-2">
            <b-col lg="12" xl="6">
              <b-form-group
                label="Buscar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                  ></b-form-input>
    
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">
                      Limpiar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="10" xl="6">
              <b-form-group
                v-model="sortDirection"
                label="Buscar por:"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-radio-group
                  v-model="filterOn"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  name="radio-inline"
                  class="mt-1"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </div>
          <b-col lg="6" class="my-1 d-md-none px-0">
            <b-form-group
              label="Ordenar:"
              label-for="sort-by-select"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
              v-slot="{ ariaDescribedby }"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  :aria-describedby="ariaDescribedby"
                  class="w-75"
                >
                  <template #first>
                    <option value="">Ninguno</option>
                  </template>
                </b-form-select>
    
                <b-form-select
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  :aria-describedby="ariaDescribedby"
                  size="sm"
                  class="w-25"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
          <div class="row mt-3" style="color: #F28C02">
              Mostrando
            {{ !totalRows ? 0 : (currentPage - 1) * perpage + 1 }} -
            {{
              !totalRows
                ? 0
                : currentPage * perpage >= totalRows
                ? totalRows
                : currentPage * perpage
            }}
            de {{ totalRows }}
            productos
          </div>
        <b-table
              :items="products"
              :fields="tableHeaders"
              :current-page="currentPage"
              :per-page="perpage"
              :filter="filter"
              :filter-included-fields="[filterOn]"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              empty-text="Sin registros para mostrar"
              empty-filtered-text="No se encontraron registros"
              stacked="md"
              show-empty
              small
              responsive
              sort-icon-left
              @filtered="onFiltered"
            >
              <template v-slot:cell(existence)="row">
                {{ quantity(row.item.batchs) }}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button
                  :id="`update-btn-${row.index}`"
                  @click="info(row.item, row.index, $event.target)"
                  variant="outline-warning btn-transparent"
                  size="xs"
                >
                  <i class="fe-edit fe-2x"></i>
                </b-button>
              </template>
        </b-table>
        <b-row class="mb-2">
            <b-col sm="6" lg="6" xl="6">
                Registros<span class="d-none d-lg-inline"> por página</span>
                <b-form-select
                  id="per-page-select"
                  v-model="perpage"
                  :options="pageOptions"
                  size="sm"
                  class="ml-2"
                  style="max-width: 60px"
                ></b-form-select>
            </b-col>
            <b-col sm="6" lg="6" xl="6">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perpage"
                align="right"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        <!-- Info modal -->
        <b-modal
          :id="infoModal.id"
          :title="infoModal.title"
          hide-footer
          @hide="resetInfoModal"
          body-class="p-0"
        >
          <b-table
            class="table-sm"
            stacked
            :fields="tableheadersproducts"
            :items="[infoModal.content]"
          >
            <template v-slot:cell(id_ext1)="row">
              {{ row.item.ext_description }} {{ row.item.id_ext1 }}
            </template>
            <template v-slot:cell(existence)="row">
              {{ quantity(row.item.batchs) }}
            </template>
            <template v-slot:cell(batchs)="row">
              <b-list-group flush>
                <b-list-group-item v-for="c in row.item.batchs" :key="c.batch" class="p-0"> 
                  <div v-if="c.quantity != 0">
                    Lote: <b-badge variant="secondary">{{ c.batch }}</b-badge> (
                    {{ c.quantity }} )
                  </div>
                  <div v-else class="text-muted text-center p-1">
                        Sin cantidades
                      </div>
                  <div v-if="has_serial(c)">
                    <h6>Seriales: </h6>
                    <ul>
                      <li v-for="s in c.serials" :key="s">
                        <b-badge variant="success">{{ s }}</b-badge>
                      </li>
                    </ul>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </template>
          </b-table>
        </b-modal>
      </b-card>
    </template>
    